import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { Dropdown } from 'core-components/library/dropdown'
import { BaseCrud, Static } from 'core-components/types'

import { getFiscalYearLabel } from '../../lib'
import { selectStrategicInitiativesYearOptions } from '../../model'

interface IStrategicInitiativesFiscalYearProps {
  fYear: number
  onChange: (fYear: number) => void
}

export const StrategicInitiativesFiscalYear = ({
  fYear,
  onChange,
}: IStrategicInitiativesFiscalYearProps) => {
  const fYears = useSelector(selectStrategicInitiativesYearOptions)

  const source = useMemo(() => {
    const crud = new BaseCrud({
      fetcher: new Static(fYears.map((year) => ({ value: year, text: getFiscalYearLabel(year) }))),
      keyField: 'value',
    })

    crud.setPaging({ page: 0, pageSize: fYears.length || 10 })

    return crud
  }, [fYears])

  if (!fYears.length) {
    return null
  }

  return (
    <Dropdown
      source={source}
      caption="text"
      value={fYear}
      onChange={(value) => onChange(Number(value))}
    />
  )
}

StrategicInitiativesFiscalYear.displayName = 'StrategicInitiativesFiscalYear'
